import { ReactElement, PropsWithChildren } from "react";

import Artwork from "appFrames/welcomeAppFrame/artwork/Artwork";
import Header from "appFrames/welcomeAppFrame/header/Header";
import PageAlert from "global-components/pageAlert/PageAlert";

import styles from "./welcome-app-frame.module.css";

const WelcomeAppFrame = ({
  headerTitle = "",
  children,
}: PropsWithChildren<{ headerTitle?: string }>): ReactElement => {
  return (
    <div className={`milo--root ${styles.container}`}>
      <div className={styles.artwork}>
        <Artwork />
      </div>
      <div className={styles.viewport}>
        <div className={styles.header}>
          <Header title={headerTitle} />
        </div>

        <div className={styles.mainContent}>
          <PageAlert />
          <div className="welcome-frame-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeAppFrame;
